












import {
  Method,

  initProxy,
} from '@internal/plugin-components-react/src/api/proxyApi';
import { PROXY_TARGETS } from '@internal/plugin-components-react/src/utils/types';
import { jiraEpicPayload } from '../src/components/utils/jira';

/**
 * Options for creating a todo client.
 *
 * @public
 */



/**
 * An implementation of the AgentApi that talks to the agent plugin backend.
 *
 * @public
 */
export class GameLaunchClient  {
  backendProxy;
  jiraProxy;
  getMethod = { method: Method.GET };

  constructor(options) {
    this.backendProxy = initProxy(PROXY_TARGETS.BACKEND, options.discoveryApi);
    this.jiraProxy = initProxy(PROXY_TARGETS.JIRA, options.discoveryApi);
  }

  async getPlatforms() {
    try {
      const response = await this.backendProxy.fetchApi(
        'gamelaunch/v1/launch/platforms',
        this.getMethod,
      );
      const platforms = await response.json();
      if (!platforms || platforms.data.length === 0)
        throw new Error('No platform options available');
      return platforms.data;
    } catch (error) {
      throw error;
    }
  }

  async getRegions() {
    try {
      const response = await this.backendProxy.fetchApi(
        'gamelaunch/v1/launch/regions',
        this.getMethod,
      );
      const region = await response.json();
      if (!region || region.data.length === 0)
        throw new Error('No region options available');
      return region.data;
    } catch (error) {
      throw error;
    }
  }

  async addGameLaunch(data) {
    const { launch_request_id, ...dataWithoutId } = data;
    const stringifiedData = JSON.stringify(dataWithoutId);
    try {
      const response = await this.backendProxy.fetchApi(
        `gamelaunch/v1/launch`,
        {
          method: Method.POST,
          body: stringifiedData,
        },
      );
      const gameLaunch = await response.json();
      return gameLaunch;
    } catch (error) {
      throw error;
    }
  }

  async updateGameLaunch(data) {
    const stringifiedData = JSON.stringify(data);
    const id = data.launch_request_id;
    try {
      const response = await this.backendProxy.fetchApi(
        `gamelaunch/v1/launch/${id}`,
        {
          method: Method.PUT,
          body: stringifiedData,
        },
      );
      const gameLaunch = await response.json();
      return gameLaunch;
    } catch (error) {
      throw error;
    }
  }

  async getGameLaunch(id) {
    try {
      const response = await this.backendProxy.fetchApi(
        `gamelaunch/v1/launch/${id}`,
        this.getMethod,
      );
      const data = await response.json();
      if (!data) throw new Error('No data found');
      return data;
    } catch (error) {
      throw error;
    }
  }

  async getGameLaunchList() {
    try {
      const response = await this.backendProxy.fetchApi(
        'gamelaunch/v1/launch/list',
        this.getMethod,
      );
      const list = await response.json();
      return list;
    } catch (error) {
      throw error;
    }
  }

  async addNote(note, launchId) {
    const newNote = { launch_request_id: launchId, notes: note };
    const stringifiedNote = JSON.stringify(newNote);
    try {
      const response = await this.backendProxy.fetchApi(
        'gamelaunch/v1/launch/notes',
        {
          method: Method.POST,
          body: stringifiedNote,
        },
      );
      const note = await response.json();
      return note;
    } catch (error) {
      throw error;
    }
  }

  async updateNote(note, noteId) {
    const newNote = { notes: note };
    const stringifiedNote = JSON.stringify(newNote);
    try {
      const response = await this.backendProxy.fetchApi(
        `gamelaunch/v1/launch/notes/${noteId}`,
        {
          method: Method.PUT,
          body: stringifiedNote,
        },
      );
      const note = await response.json();
      return note;
    } catch (error) {
      throw error;
    }
  }

  async deleteNote(noteId) {
    try {
      const response = await this.backendProxy.fetchApi(
        `gamelaunch/v1/launch/notes/${noteId}`,
        {
          method: Method.DELETE,
        },
      );
      const note = await response.json();
      return note;
    } catch (error) {
      throw error;
    }
  }

  async getJiraEpic(jiraEpic) {
    try {
      const response = await this.jiraProxy.fetchApi('rest/api/3/search', {
        method: Method.POST,
        body: jiraEpicPayload(jiraEpic),
      });
      const tasks = await response.json();
      return tasks.issues;
    } catch (error) {
      throw error;
    }
  }

  async getArmadaCalculationList(
    launchRequestId,
  ) {
    try {
      const response = await this.backendProxy.fetchApi(
        `gamelaunch/v1/launch/armadacalculations/list?launch_request_id=${launchRequestId}`,
        {
          method: Method.GET,
        },
      );
      const armadaCalculations = await response.json();
      return armadaCalculations.data;
    } catch (error) {
      throw error;
    }
  }

  async addArmadaCalculation(
    payload,
  ) {
    try {
      const response = await this.backendProxy.fetchApi(
        `gamelaunch/v1/launch/armadacalculations`,
        {
          method: Method.POST,
          body: JSON.stringify(payload),
        },
      );
      const armadaCalculation = await response.json();
      return armadaCalculation;
    } catch (error) {
      throw error;
    }
  }

  async updateArmadaCalculation(
    payload
,
  ) {
    try {
      const response = await this.backendProxy.fetchApi(
        `gamelaunch/v1/launch/armadacalculations/${payload.armada_calculation_id}`,
        {
          method: Method.PUT,
          body: JSON.stringify(payload),
        },
      );
      const armadaCalculation = await response.json();
      return armadaCalculation;
    } catch (error) {
      throw error;
    }
  }

  async deleteArmadaCalculation(
    armada_calculation_id,
  ) {
    try {
      const response = await this.backendProxy.fetchApi(
        `gamelaunch/v1/launch/armadacalculations/${armada_calculation_id}`,
        {
          method: Method.DELETE,
        },
      );
      const armadaCalculation = await response.json();
      return armadaCalculation;
    } catch (error) {
      throw error;
    }
  }
}
